import { render, staticRenderFns } from "./hatch-enrichment-btn.vue?vue&type=template&id=15b8c10a&"
import script from "./hatch-enrichment-btn.vue?vue&type=script&lang=js&"
export * from "./hatch-enrichment-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports